<template>
  <div>

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            Verificar cuenta
            <div class="card-actions">
              <button class="btn btn-primary" v-b-tooltip.hover title="Volver al inicio" v-if="!procesando" @click="Inicio()" >
                <i class="icon-arrow-left"></i>
              </button>
            </div>
          </div>
          <div class="card-body">

            <b-alert show class="text-center" variant="info" v-if="procesando == true">
              <b-progress height="20px" :max="100" variant="info" striped :animated="true">
                <b-progress-bar :value="100" :label="'&lt;strong&gt;Procesando...&lt;/strong&gt;'">
                </b-progress-bar>
              </b-progress>
            </b-alert>
            <b-alert show class="text-center" variant="info" v-else-if="procesando == false && error == false && cuenta_verificada == true">
              <h3>Felicitaciones!!!</h3>
              {{mensaje_success}}
              <br />
              <br />
              <b-button type="button" variant="success" @click="abrirModalInicioSesion()">Iniciar sesión</b-button>
            </b-alert>
            <b-alert show class="text-center" variant="danger" v-else-if="procesando == false && error == true && cuenta_verificada == false">
              {{mensaje_error}}
            </b-alert>

          </div>
        </div>
      </div>
      <!--/.col-->
    </div>
    <!--/.row-->

  </div>
</template>

<script>
import router from '@/router/index.js'
import usuario from '@/js/usuario.js'

export default {
  name: 'usuario-verificar-cuenta',
  mounted () {
    this.cuenta_verificada = false
    this.procesando = false
    this.error = false

    this.token_verificacion = this.$route.params.token_verificacion
    this.verificarCuenta()
  },
  data () {
    return {
      procesando: false,
      error: false,
      cuenta_verificada: false,
      token_verificacion: null,
      mensaje_error: 'Se ha presentado un error en el sistema. Por favor intente más tarde. Si el error continua por favor comuníquese con el administrador del sistema.',
      mensaje_success: 'Cuenta verificada satisfactoriamente. Ya puede iniciar sesión.'
    }
  },
  methods: {
    verificarCuenta () {
      this.cuenta_verificada = false
      this.procesando = true
      this.error = false

      usuario.token_verificacion = this.token_verificacion
      usuario.verificarCuenta().then(response => {
        if (response.status === 'success') {
          this.cuenta_verificada = true
          this.procesando = false
          this.error = false
        } else {
          this.cuenta_verificada = false
          this.procesando = false
          this.error = true
          // console.log(response)
        }
      })
    },
    abrirModalInicioSesion () {
      this.Inicio()
      this.$parent.$parent.$children[0].$children[1].abrirModalInicioSesion()
    },
    Inicio () {
      router.push({
        name: 'home'
      })
    }
  }

}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/Usuario/VerificarCuenta.vue